import { useSelectedLanguageName } from '@/hooks/useSelectedLanguageName'
import ContinueButton from '@app-studio-web/ui/components/ContinueButton'
import i18n from 'i18next'
import { useTranslation } from 'react-i18next'
import { Form } from 'react-router-dom'
import QuizLayout from './QuizLayout'

const TITLE = 'pages.quizOnboarding.planPreview.title'

// Rising confidence projection over the first weeks.
const PROJECTION_BARS = [
  { labelKey: 'pages.quizOnboarding.planPreview.week1', value: 20 },
  { labelKey: 'pages.quizOnboarding.planPreview.week2', value: 45 },
  { labelKey: 'pages.quizOnboarding.planPreview.week3', value: 70 },
  {
    labelKey: 'pages.quizOnboarding.planPreview.week4',
    value: 95,
    highlight: true,
  },
]

export default function PlanPreviewPage() {
  const { t } = useTranslation()
  const language = useSelectedLanguageName()

  // Today + 21 days, formatted like "August 11".
  const targetDate = new Date(Date.now() + 21 * 24 * 60 * 60 * 1000)
  const date = targetDate.toLocaleDateString(i18n.language || 'en', {
    month: 'long',
    day: 'numeric',
  })

  return (
    <QuizLayout>
      <div className="flex grow flex-col justify-center gap-8">
        <div className="space-y-3 text-center">
          <h1 className="text-custom-black text-2xl font-extrabold text-balance md:text-3xl">
            {t(TITLE, { language })}
          </h1>
          <p className="text-custom-black text-[15px] font-semibold">
            {t('pages.quizOnboarding.planPreview.byDate', { date })}
          </p>
          <p className="mx-auto max-w-md text-[15px] leading-relaxed text-[#4a5568]">
            {t('pages.quizOnboarding.planPreview.body')}
          </p>
        </div>

        <div className="mx-auto w-full max-w-sm rounded-3xl border border-[#e2e8f0] bg-white p-6">
          <p className="mb-6 text-center text-sm font-semibold text-[#4a5568]">
            {t('pages.quizOnboarding.planPreview.chartTitle')}
          </p>
          <div className="flex items-end justify-center gap-4">
            {PROJECTION_BARS.map((bar) => (
              <div
                key={bar.labelKey}
                className="flex w-14 flex-col items-center justify-end"
              >
                <div
                  className={`w-full rounded-t-2xl rounded-b-md ${
                    bar.highlight
                      ? 'from-primary bg-gradient-to-t to-[#5aa9ff]'
                      : 'bg-[#cbd5e1]'
                  }`}
                  style={{ height: `${Math.round((bar.value / 95) * 160)}px` }}
                />
                <span
                  className={`mt-2 text-center text-xs ${
                    bar.highlight ? 'text-primary font-bold' : 'text-[#94a3b8]'
                  }`}
                >
                  {t(bar.labelKey)}
                </span>
              </div>
            ))}
          </div>
        </div>

        <p className="text-center text-xs text-[#94a3b8]">
          {t('pages.quizOnboarding.planPreview.footnote')}
        </p>
      </div>

      <Form className="shrink-0" method="post">
        <input
          name={t(TITLE, { lng: 'en', language })}
          type="hidden"
          value={t('shared.continue', { lng: 'en' })}
        />

        <ContinueButton />
      </Form>
    </QuizLayout>
  )
}
